
import api from "@/services/api"
import { Status } from "@/types/status"

class ApiStatus {
    private axios: any;
    public constructor (axios: any) { this.axios = axios }

    public async statusList (): Promise<Status[]> { return (await this.axios.get("/status")).data }
    public async statusSave (status: Status): Promise<string> { return (await this.axios.post("/status", status)).data }
    public async statusDelete (status: Status): Promise<void> { await this.axios.delete(`/status/${status.id}`) }
    public async statusDefault (status: Status): Promise<void> { await this.axios.put(`/status/default/${status.id}`) }
}

const apiStatus = new ApiStatus(api.getAxios())
export default apiStatus
